export const loader = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]
